import { QueryOptions, queryOptions, useMutation } from '@tanstack/react-query';
import { service } from '@maia/task';
import { queryClient } from '../../../main';

export type Tasks = Awaited<ReturnType<(typeof service)['getTasks']>>;

export function getTasksOptions(
  search: Record<string, unknown> = {},
  initialData: QueryOptions<Tasks>['initialData'] = undefined,
) {
  return queryOptions({
    queryKey: ['tasks', search],
    queryFn: async () => await service.getTasks(search),
    initialData,
  });
}

export function useUpdateOptions() {
  return useMutation({
    mutationFn: async (
      params: Parameters<typeof service.updateOptions>[number],
    ) => await service.updateOptions({ ...params }),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ['tasks'],
        exact: false,
      }),
  });
}
